import React from 'react'
import { Provider } from 'react-redux'
import { compose } from 'redux'
import { hot } from 'react-hot-loader/root'
import useStore from 'store'
import { BrowserRouter as Router } from 'react-router-dom'
import Routes from 'routes/auth'
import isDevelop from 'utils/isDevelop'
import chromeExtComposer from 'utils/chromeExtComposer'
import { initialState as authInitialState } from 'reducers/auth'
import Navbar from 'components/shared/navbar'
import Footer from 'components/shared/footer'

const composer = isDevelop ? chromeExtComposer : compose

const defaultState = {
  auth: {
    csrfToken: null,
    formPath: null,
    target: null,
    authenticated: false,
    user: {
      roles: [],
    },
  },
  notification: {
    type: '',
    message: '',
  },
}

const { auth, notification } = !window.preloadedState ? defaultState : window.preloadedState

const preloadedState = {
  auth: {
    ...authInitialState,
    ...auth,
    user: {
      ...auth.user,
      roles: auth.user ? auth.user.roles.map((role) => role.name.toLowerCase()) : [],
    },
  },
  notification,
}

const store = useStore(composer, preloadedState)

const Admin = () => (
  <Provider store={store}>
    <Router>
      <Navbar />
      <Routes />
      <Footer />
    </Router>
  </Provider>
)

export default hot(Admin)
